// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__VPDNo","content":"LayoutSettings_content__1STMX"};